export default __webpack_public_path__ + "static/media/step_005.f9132210.jpeg";